import styled, { css } from 'styled-components';

import ContentSection from '@/components/Base/ContentSection';
import { CONTENT_POSITION_TYPES } from '@/constants';
import { colorBorder, mediaQueryDesktopMin } from '@/styleUtils';

export const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 12px;
`;

export const Blocks = styled(ContentSection)`
  border-radius: 0;
  box-shadow: 0 -1px 0 0 ${colorBorder} inset;

  &:first-of-type {
    border-radius: 12px 12px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 12px 12px;
  }

  ${({ position, $isRemoveStyles, $botomLinkBlocks }) => {
    if (
      position === CONTENT_POSITION_TYPES.headerTop ||
      position === CONTENT_POSITION_TYPES.headerBottom
    ) {
      return css`
        padding: 0;
        margin: 0;
        box-shadow: none;
        @media ${mediaQueryDesktopMin} {
          padding: 0;
        }
      `;
    }
    if (
      position === CONTENT_POSITION_TYPES.asideBottom ||
      position === CONTENT_POSITION_TYPES.asideTop
    ) {
      return css`
        @media ${mediaQueryDesktopMin} {
          padding: 16px;
        }
      `;
    }
    if ($isRemoveStyles) {
      return css`
        padding: 0;
        box-shadow: none;
        margin-bottom: 0;
      `;
    }
    if ($botomLinkBlocks) {
      return css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 16px;
      `;
    }

    return '';
  }}
`;
